import axios from "axios";

const API = axios.create({
  baseURL: "https://flavoursnest-be.onrender.com/admin", // change if needed
  // baseURL: "http://localhost:5000/admin", // change if needed

});

API.interceptors.request.use((config) => {

  const token = localStorage.getItem("adminToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;

});

export const adminLogin = (data) => {
  return axios.post("https://flavoursnest-be.onrender.com/auth/admin-login", data);
  // return axios.post("http://localhost:5000/auth/admin-login", data);

};
// ================= CATEGORY APIs =================

export const getAllCategories = () => {
  return API.get("/categories");
};

export const addCategory = (formData) => {
  return API.post("/add-category", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const deleteCategory = (id) => {
  return API.delete(`/delete-category/${id}`);
};

export const getRecipesByCategory = (category_id) =>
  API.get(`/recipes/${category_id}`);

export const addRecipe = (formData) =>
  API.post("/add-recipe", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  export const updateRecipe = (id, formData) =>
  API.put(`/update-recipe/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteRecipe = (id) =>
  API.delete(`/recipes/${id}`);

// ================= RECIPE =================

export const getRecipeById = (id) =>
  API.get(`/recipes-collection/${id}`);

export const getRecipeDetails = (recipeId) =>
  API.get(`/recipe-details/${recipeId}`);

export const addRecipeDetails = (data) =>
  API.post(`/add-recipe-details`, data);

export const updateRecipeDetails = (id, data) =>
  API.put(`/update-recipe-details/${id}`, data);

// ================= INGREDIENTS =================

export const getIngredients = (detailsId) =>
  API.get(`/recipe-ingridients/${detailsId}`);

export const addIngredients = (data) =>
  API.post(`/add-recipe-ingridients`, data);

export const updateIngredients = (data) =>
  API.put(`/update-recipe-ingridients`, data);

// ================= DASHBOARD (ANALYTICS) =================

// Dashboard stats
export const getDashboardStats = () => {
  return API.get("/dashboard");
};

// Top recipes
export const getTopRecipes = () => {
  return API.get("/top-recipes");
};
  
export default API;